import AScene from "../library/ExtendedObjects/AScene.js";
import gameData from "../gameData.js";

export default class GameMenu
{
    /**
     * @param {AScene} scene 
     */
    constructor(scene, animateIn = false)
    {
        this.scene = scene;

        this.menuBtn = this.scene.addButton(53, 53, "MenuBtn", ()=>{
            this.displayMenu();
        });
        this.scene.addDropShadow(this.menuBtn, 3, 4);
        if(animateIn) 
        {
            this.scene.addTween(this.menuBtn.setScale(0), 500, {scaleX: 1, scaleY: 1}, "Back");
        }

        this.overlay = this.scene.addRect(0, 0, this.scene.size.width, this.scene.size.width, 0x000000);
        this.overlay.setDepth(100);
        this.overlay.alpha = 0;
        this.overlay.setInteractive();
        this.overlay.on('pointerdown', ()=>{
            this.hideMenu();
        });

        this.mainMenu = this.scene.add.container(this.scene.mid.x, this.scene.mid.y);
        this.mainMenu.setDepth(101);
        this.mainMenu.setScale(0);
        this.mainMenu.y = this.scene.mid.y + 200;
        this.mainMenu.alpha = 0;
        this.mainMenu.bg = this.scene.addImage(0, 0, "Menu_PopupSm", this.mainMenu);
        this.homeBtn = this.scene.addButton(-70, -5, "Menu_HomeBtn", ()=>{
            this.displayConfirmation("Are you sure you want to exit?", ()=>{
                this.scene.scene.start("Intro");
            });
        }, this.mainMenu);
        this.helpBtn = this.scene.addButton(55, -5, "Menu_LearnBtn", ()=>{
            this.displayConfirmation("Replay learning mode?", ()=>{
                this.scene.scene.start("Descriptions");
            });
        }, this.mainMenu);

        this.confirmationMenu = this.scene.add.container(this.scene.mid.x, this.scene.mid.y);
        this.confirmationMenu.setDepth(101);
        this.confirmationFunction = null;
        this.confirmationMenu.bg = this.scene.addImage(0, 0, "Menu_PopupLg", this.confirmationMenu);
        this.confirmationMenu.text = this.scene.addText(0, -70, 24, 0xffffff, gameData.fonts.comfortaa_bold, "Are you sure you want to exits?", this.confirmationMenu, true);
        this.confirmationMenu.text.setWordWrapWidth(280);
        this.scene.addButton(-70, 30, "Menu_ChkBtn", ()=>{
            this.confirmationFunction();
        }, this.confirmationMenu);
        this.scene.addButton(55, 30, "Menu_XBtn", ()=>{
            this.hideMenu();
        }, this.confirmationMenu);
        this.confirmationMenu.scaleX = 0;

        this.displayStates = { none: 0, main: 1, confirmation: 2 };
        
    }

    displayConfirmation(confirmationText, onExecute)
    {
        this.curState = this.displayStates.confirmation;
        this.killTweens();

        this.confirmationFunction = onExecute;
        this.scene.addTween(this.mainMenu, 200, {scaleX: 0}, Phaser.Math.Easing.Sine.Out, ()=>{
            this.confirmationMenu.alpha = 1;
            this.confirmationMenu.y = this.scene.mid.y;
            this.confirmationMenu.scaleY = 1;
            this.scene.addTween(this.confirmationMenu, 1000, {scaleX: 1, easeParams: [.01, .7]}, "Elastic");
        });
        this.confirmationMenu.text.text = confirmationText;
    }

    hideMenu()
    {
        this.killTweens();
        
        this.scene.addTween([this.confirmationMenu, this.mainMenu], 300, {y: this.scene.mid.y + 200, scaleX: 0, scaleY: 0, alpha: 0}, Phaser.Math.Easing.Sine.Out);
        this.scene.addTween(this.overlay, 200, {alpha: 0});

        this.curState = this.displayStates.none;
    }

    displayMenu()
    {
        this.curState = this.displayStates.main;
        this.killTweens();

        this.scene.addTween(this.mainMenu, 300, {y: this.scene.mid.y, scaleX: 1, scaleY: 1, alpha: 1}, Phaser.Math.Easing.Sine.Out);
        this.scene.addTween(this.overlay, 200, {alpha: .3});
    }

    killTweens()
    {
        this.scene.killTween(this.mainMenu);
        this.scene.killTween(this.overlay);
        this.scene.killTween(this.confirmationMenu);
    }
}